import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';

const apiUrl = CommonConstants.Actions.api;
const f3Url = CommonConstants.Actions.f3;

export function getAddress(token) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        axios.get(apiUrl + 'address', {
            token,
        }).then((response) => {
            dispatch({type: 'GET_ADDRESS_FULFILLED', payload: response.data,})

        }).catch((err) => {
            dispatch({type: 'ADDRESS_REJECTED', payload: err,})
        })
    }
}

export function getProvinces(cc = 'PH') {
    return function (dispatch) {
        axios.get(f3Url + 'locations/countries/' + cc + '/provinces?per_page=0')
            .then((response) => {
                dispatch({type: 'GET_PROVINCE_FULFILLED', payload: response.data,})

            }).catch((err) => {
            dispatch({type: 'GET_PROVINCE_REJECTED', payload: err,})
        })
    }
}

export function getCities(id) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        if (id) {
            axios.get(f3Url + 'locations/provinces/' + id + '/cities?per_page=0')
                .then((response) => {
                    dispatch({type: 'GET_CITY_FULFILLED', payload: response.data,})

                }).catch((err) => {
                dispatch({type: 'GET_CITY_REJECTED', payload: err,})
            })
        }

    }
}

export function getDistricts(id) {
    return function (dispatch) {
        if (id) {
            axios.get(f3Url + 'locations/cities/' + id + '/districts?per_page=0')
                .then((response) => {
                    dispatch({type: 'GET_DISTRICT_FULFILLED', payload: response.data,})

                }).catch((err) => {
                dispatch({type: 'GET_DISTRICT_REJECTED', payload: err,})
            })
        }

    }
}

export function getRegions() {
    return function (dispatch) {
        axios.get(f3Url + 'locations/regions')
            .then((response) => {
                dispatch({type: 'GET_REGION_FULFILLED', payload: response.data,})

            }).catch((err) => {
            dispatch({type: 'GET_REGION_REJECTED', payload: err,})
        })
    }
}

export function addAddress(parameters) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        return axios.post(
            apiUrl + 'addresses',
            {
                "data": {
                    "type": "addresses",
                    "attributes": {
                        "first_name": parameters.first_name,
                        "last_name": parameters.last_name,
                        "middle_initial": "",
                        "line_1": parameters.line_1,
                        "line_2": parameters.line_2,
                        "city": parameters.city,
                        "postal_code": parameters.postal_code,
                        "region": parameters.region,
                        "state": parameters.state,
                        "type": "delivery",
                        "country_code": parameters.country_code,
                        "phone_number": parameters.phone_number
                    }
                }
            }
        ).then((response) => {
            dispatch({type: 'ADD_ADDRESS_FULFILLED', payload: response.data,})
            return response;
        }).catch((err) => {
            dispatch({type: 'ADDRESS_REJECTED', payload: err,})
            return err;
        })
    }
}

export function editAddress(id, parameters) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        axios.put(
            apiUrl + 'addresses/' + id,
            {
                "data": {
                    "type": "addresses",
                    "attributes": {
                        "first_name": parameters.first_name,
                        "last_name": parameters.last_name,
                        "middle_initial": "",
                        "line_1": parameters.line_1,
                        "line_2": parameters.line_2,
                        "city": parameters.city,
                        "postal_code": parameters.postal_code,
                        "region": parameters.region,
                        "state": parameters.state,
                        "type": "delivery",
                        "country_code": parameters.country_code,
                        "phone_number": parameters.phone_number
                    }
                }
            }
        ).then((response) => {
            dispatch({type: 'UPDATE_ADDRESS_FULFILLED', payload: response.data,})

        }).catch((err) => {
            dispatch({type: 'ADDRESS_REJECTED', payload: err,})
        })
    }
}

export function deleteAddress(id) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        return axios.delete(apiUrl + 'addresses/' + id).then((response) => {
            dispatch({type: 'DELETE_ADDRESS_FULFILLED', payload: response.data, address_id: id})
            return response
        }).catch((err) => {
            dispatch({type: 'ADDRESS_REJECTED', payload: err,})
        })
    }
}

export function setDefaultAddress(addressId) {
    return function (dispatch) {
        dispatch({type: 'RESET_UPDATE_ACCOUNTS',})
        axios.put(
            apiUrl + 'users/update-default-address',
            {
                "data": {
                    "type": "user-update-default-address",
                    "attributes": {
                        "address_id": addressId
                    }
                }
            }
        ).then((response) => {
            dispatch({type: 'DEFAULT_ADDRESS_FULFILLED', payload: response.data,})

        }).catch((err) => {
            dispatch({type: 'ADDRESS_REJECTED', payload: err,})
        })
    }
}

export function resetLocationCalls(find) {
// 'GET_DISTRICT_FULFILLED'
// 'GET_CITY_FULFILLED'
    return function (dispatch) {
        dispatch({
            type: find,
            payload: false,
        })
    }
}






/** WEBPACK FOOTER **
 ** ./src/actions/AddressAction.js
 **/